import { addPendo } from '@ecoonline/pendo-integration'

export default class TrackingService {
  constructor (config) {
    this.config = config
  }

  addScripts () {
    this.addGoogleTagManager()
    this.addGainsight()
  }

  addGoogleTagManager () {
    if (this.config.environment !== 'production') return

    (function (w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      })
      const f = d.getElementsByTagName(s)[0]
      const j = d.createElement(s)
      j.async = true
      j.src = `https://www.googletagmanager.com/gtm.js?id=${i}`
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', 'dataLayer', 'GTM-NRD8TJQ')
  }

  addGainsight () {
    // https://support.gainsight.com/PX/Install_PX/01_Install_Gainsight_PX_on_your_web_app
    // API-Keys & Integration code snippet is provided by UX Team / Gainsight Admin

    const gainsightKey = this.config.gainsightApiKey

    if (gainsightKey) {
      (function (n, t, a, e, co) {
        const i = 'aptrinsic'
        n[i] = n[i] || function () {
          (n[i].q = n[i].q || []).push(arguments)
        }
        n[i].p = e
        n[i].c = co
        const r = t.createElement('script')
        r.async = !0
        r.src = a + '?a=' + e
        const c = t.getElementsByTagName('script')[0]
        c?.parentNode?.insertBefore(r, c)
      })(window, document, 'https://web-sdk.aptrinsic.com/api/aptrinsic.js', gainsightKey)
    }
  }

  identifyUser (user) {
    if (!window.aptrinsic) return

    aptrinsic('identify',
      { id: user.sub }
    )
  }

  setupPendo (user) {
    const { config } = this
    const { enablePendo, pendoKey, environment } = config
    if (!user || !enablePendo || !pendoKey) return

    addPendo({
      productIdentifier: 'platform',
      production: environment === 'production',
      apiKey: pendoKey,
      userData: {
        email: user.email,
        role: user.superadmin ? 'Admin' : 'Non-admin',
        fullName: user.name,
        crm: user.crm_number,
        companyName: user.company_name,
        accountType: user.company_type,
        language: user.rfc_language
      }
    })
  }
}
